import React from 'react';

import { FlexibleSkeleton } from 'app/component/skeleton/flexible/FlexibleSkeleton';
import { PlateSkeleton } from 'app/component/skeleton/plate/PlateSkeleton';
import { RepeatComponent } from 'app/component/repeat-component/RepeatComponent';
import { FieldSkeleton } from 'app/component/skeleton/field/FieldSkeleton';
import { useIsDesktop, useWindowType } from 'app/utils/useWindowType';

export const SmsSignSkeleton = () => {
    const [windowType] = useWindowType();
    const [isDesktop] = useIsDesktop();

    return (
        <>
            <PlateSkeleton windowType={windowType} />
            <div
                style={{
                    marginTop: 24,
                    height: 32,
                    width: isDesktop ? '50%' : '100%',
                }}
            >
                <FlexibleSkeleton windowType={windowType} />
            </div>
            <div style={{ marginTop: 8 }}>
                <RepeatComponent numberRepetitions={2}>
                    <div style={{ marginTop: 24 }}>
                        <FieldSkeleton windowType={windowType} />
                    </div>
                </RepeatComponent>
            </div>
        </>
    );
};
